import { axiosInstance } from ".."

const currencyList = async (gatewayCode) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/entity/currency?gateway=${gatewayCode}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default currencyList;